/** API access accepts the global permission used by the collaborator form.
 * Screen and feature access remain controlled by the existing Can components.
 */
export function canWriteHCPProductionBatches(user?: { permissions?: readonly string[] } | null): boolean {
  return Boolean(user?.permissions?.some((permission) => permission === 'all' || permission === 'orders:write'))
}

export const HCP_BATCH_OPERATIONS_FEATURE = 'feature:hcp-divisao-retrabalho-card'
export const HCP_BATCH_OPERATIONS_PERMISSION = `${HCP_BATCH_OPERATIONS_FEATURE}:manage`

/** This action requires explicit opt-in, including for HCP/global administrators. */
export function canCreateHCPDerivedBatches(user?: { permissions?: readonly string[]; permissionsScreens?: readonly string[] } | null): boolean {
  return canWriteHCPProductionBatches(user)
    && Boolean(user?.permissionsScreens?.includes(HCP_BATCH_OPERATIONS_PERMISSION))
}
